import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  queryMyCouponReceive: '/coupon/couponReceive/queryMyCouponReceive',
  queryCouponReceive: '/coupon/couponReceive/queryCouponReceive',
  queryMyCouponForGoods: '/coupon/couponReceive/queryMyCouponForGoods',
  produceCoupon: '/coupon/couponReceive/produceCoupon',
};

/**
 * 获取用户优惠券列表
 * @returns {{result: unknown, getList: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useQueryMyCouponReceive = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.queryMyCouponReceive,
      method: 'get',
      data: q || {}
    }, { noAlias: true, token: true });
  }, {
    manual: true
  });
  
  return {
    result: data || {},
    loading,
    error,
    getList: runAsync
  };
};

/**
 * 获取首页优惠券列表
 * @param query
 * @returns {{result: unknown, getCouponList: (...params: any[]) => void, loading: boolean, error: Error}}
 */
export const useQueryCouponReceive = (query) => {
  const { data, run, error, loading } = useRequest(() => {
    return http({
      url: apiPath.queryCouponReceive,
      method: 'get',
      data: query
    }, { noAlias: true });
  });
  
  return {
    result: data || {},
    loading,
    error,
    getCouponList: run
  };
};

/**
 * 提交订单页 获取可用优惠券
 * @param query
 * @returns {{result: unknown, getCoupon: (...params: any[]) => void, loading: boolean, error: Error}}
 */
export const useQueryMyCouponForGoods = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.queryMyCouponForGoods,
      method: 'post',
      data: q || {}
    }, { noAlias: true, json: true });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    error,
    getCoupon: runAsync
  };
};

export const useProduceCoupon = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.produceCoupon,
      method: 'get',
      data: q || {}
    });
  }, { manual: true });
  return {
    result: data || {},
    loading,
    error,
    recevierCouponHandle: runAsync
  };
};
